"use client";

import { useEffect } from "react";
import { useUser } from "@clerk/nextjs";
import { usePathname } from "next/navigation";
import useSavedFilters from "@/hooks/useSavedFilters";
import { useCollectionsStore } from "@/stores/collectionsStore";
import { useUiStore } from "@/stores/uiStore";

/**
 * Loads user-owned data independently of the search route context. The
 * navbar's autocomplete reads saved filters from Zustand, so it can keep
 * showing preset suggestions without mounting SearchProvider globally.
 */
export default function GlobalUserDataLoader() {
  const { user } = useUser();
  const pathname = usePathname();
  const { loadSavedFilters } = useSavedFilters();
  const { loadCollections } = useCollectionsStore((state) => state.actions);
  const userDataLoaded = useUiStore((state) => state.userDataLoaded);
  const setUserDataLoaded = useUiStore((state) => state.actions.setUserDataLoaded);

  useEffect(() => {
    if (!user || userDataLoaded) return;

    loadSavedFilters({ refreshCache: true });

    if (!pathname.includes("/favorites/public/")) {
      loadCollections();
    }

    setUserDataLoaded(true);
  }, [user, userDataLoaded, pathname, loadSavedFilters, loadCollections, setUserDataLoaded]);

  return null;
}
